var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/schema";
import { withPrefix } from "@/utils/redirect";
const _getDatasets = fetcher.path("/api/datasets").method("get").create();
/** Datasets request helper **/
export function getDatasets(options = {}) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = {};
        if (options.sortBy) {
            const sortPrefix = options.sortDesc ? "-dsc" : "-asc";
            params.order = `${options.sortBy}${sortPrefix}`;
        }
        if (options.limit) {
            params.limit = options.limit;
        }
        if (options.offset) {
            params.offset = options.offset;
        }
        if (options.query) {
            params.q = ["name-contains"];
            params.qv = [options.query];
        }
        const { data } = yield _getDatasets(params);
        return data;
    });
}
const _copyDataset = fetcher.path("/api/histories/{history_id}/contents/{type}s").method("post").create();
export function copyDataset(datasetId, historyId, type = "dataset", source = "hda") {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield _copyDataset({
            history_id: historyId,
            type,
            source: source,
            content: datasetId,
        });
        return response.data;
    });
}
const _updateTags = fetcher.path("/api/tags").method("put").create();
export function updateTags(itemId, itemClass, itemTags) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield _updateTags({
            item_id: itemId,
            item_class: itemClass,
            item_tags: itemTags,
        });
        return data;
    });
}
export function getCompositeDatasetLink(historyDatasetId, path) {
    // TODO: historyDatasetId is wrong here, we should expose the route without forcing to provide a history id
    return withPrefix(`/api/histories/${historyDatasetId}/contents/${historyDatasetId}/display?filename=${path}`);
}
const getDataset = fetcher.path("/api/histories/{history_id}/contents/{id}").method("get").create();
export function getCompositeDatasetInfo(id) {
    return __awaiter(this, void 0, void 0, function* () {
        // TODO: ${id} as history id is wrong here, we should expose the route without forcing to provide a history id
        const { data } = yield getDataset({ history_id: id, id });
        return data;
    });
}
